<div #chatContent class="chat-content" cdkScrollable (scroll)="onScroll()">
  <ng-content />
</div>

<div class="new-messages-marker" [class.show]="showNewMessageIndicator">
  @if (showNewMessageIndicator) {
    <div class="new-messages-marker-content">
      <button mat-flat-button color="primary" (click)="scrollToBottom()" [class.mat-custom-color]="customColor()">
        <mat-icon>arrow_downward</mat-icon>
        {{ downArrowText() }}
      </button>
    </div>
  }
</div>
